export const instaLink = 'https://www.instagram.com/haveyoueatensydney/';
export const fbLink = 'https://www.facebook.com/haveyoueatensydney';
export const newsletterSignupLink = 'https://cdn.forms-content.sg-form.com/b0096548-5b8a-11eb-b048-be1f6fa4bac5';
export const patreonLink = 'https://www.patreon.com/haveyoueaten?fan_landing=true';